/**
 * Elements which finds all elements based on a DOM query, then
 * provides way to `render` modify each element based on the id
 * attached to it
 *
 * @param {query, render}
 * @returns DynamicElement
 */
export default function DynamicElement({ query, render: r } = {}) {
  var elements;

  function refresh() {
    // Get all elements
    elements = document.querySelectorAll(query);

    // Convert array of elements to map:
    // {
    //    id: [el, el, ...],
    //    ...
    // }
    elements = [].slice.call(elements).reduce((map, el) => {
      var id = el.getAttribute('data-id');
      if (!map[id]) {
        map[id] = [];
      }
      map[id].push(el);
      return map;
    }, {});
  }

  function render(id) {
    if (!id) {
      Object.keys(elements).forEach(id => {
        elements[id].forEach(el => r(id, el));
      });
    } else if (elements[id]) {
      elements[id].forEach(el => r(id, el));
    }
  }

  refresh();

  return {
    render,
    refresh,
  };
}
